import classNames from 'classnames';
import React, { memo, useMemo } from 'react';
import Icon from '../Controls/Icon/Icon';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import './style.scss';

interface IProps {
  message: string;
  //
  withoutIcon?: boolean;
  iconName?: Icons;
  iconColor?: string;
  iconSize?: number;
  iconClassName?: string;
  //
  justify?: 'start' | 'center' | 'end';
  className?: string;
  messageClassName?: string;
}

const FullScreenMessage: React.FC<IProps> = ({
  justify = 'center',
  iconName = Icons.Warning,
  iconColor = theme.colors.red,
  iconSize = 150,
  ...props
}: IProps): JSX.Element | null => {
  const wrapperClassName = useMemo((): string => {
    let className: string = `d-flex flex-column flex-grow-1 align-items-center justify-content-${justify}`;

    if (props.className) className += ` ${props.className}`;

    return className;
  }, [justify, props.className]);

  if (!props.message) return null;

  return (
    <div className={wrapperClassName}>
      {!props.withoutIcon ? <Icon name={iconName} size={iconSize} color={iconColor} className={`mb-4 ${props.iconClassName || ''}`} /> : null}
      <p className={classNames('full-screen-message', props.messageClassName)}>{props.message}</p>
    </div>
  );
};

export default memo(FullScreenMessage);
